export default "__VITE_ASSET__G0GwsrkH__"